/**
 * Created by mykurisu on 2017/9/4.
 */
import React from 'react'
import axios from 'axios'
import {Button, Toast} from 'react-weui'
import '../styles/record/RecordQrcode.css'
import {isLZWKAPP} from '../utils'

class CustomerServicePage extends React.Component {

    constructor() {
        super();
        this.state = {
            qrcode: '',
            showLoading: false
        }
    }

    componentWillMount () {
        if (isLZWKAPP()) {
            const accountId = this.props.location.query.account_id || ''
            location.replace(`http://www.sobot.com/chat/h5/index.html?sysNum=2bb4e90ec61441ea97ce8f5f3484856c&telShowFlag=true&partnerId=${accountId}`)
        }
    }

    componentDidMount() {
        this.setState({showLoading: true});
        axios.get('/api/board/service/allocate').then(res => {
            if (res.data.code === 0){
                this.setState({
                    qrcode: res.data.data.qrcode_img,
                    showLoading: false
                })
            }
        })
    }

    render() {
        if (isLZWKAPP()) {
            return null
        }
        return (
            <div className="record-page-qrcode">
                <Toast icon="loading" show={this.state.showLoading}>二维码获取中</Toast>
                <div className="record-page-qrcode_img">
                    <img className="qrcode-img" src={this.state.qrcode} alt=""/>
                </div>
                <div className="record-page-qrcode_title">
                    <p>联系客服</p>
                    <p>长按扫码添加客服；添加时，请备注咨询事项。</p>
                </div>
                <div className="record-page-qrcode_btn">
                    <Button onClick={() => window.history.back()} size="normal">返回</Button>
                    <Button onClick={() => window.location.href = '/'} size="normal" type="default">回到首页</Button>
                </div>
            </div>
        )
    }
}

export default CustomerServicePage 



// WEBPACK FOOTER //
// ./src/pages/CustomerServicePage.js